import { useEffect } from "react";
import { useMap } from "react-map-gl";
import { useMapStore } from "..";
import useNavigateToProperty from "./useNavigateToProperty";

const zoomThreshold = 16;

export default function useOpenPropertyOnDoubleClick() {
    const map = useMap().map!;
    const mapStore = useMapStore();
    const navigateToProperty = useNavigateToProperty();

    useEffect(() => {
        if (!map) return;

        mapStore.viewState.zoom > zoomThreshold
            ? map.getMap().doubleClickZoom.disable()
            : map.getMap().doubleClickZoom.enable();
    }, [map, mapStore.viewState.zoom]);

    useEffect(() => {
        const unsubscribeMouseDoubleClick = mapStore.onMouseDoubleClick("open-property-on-dblclick", (feature, event) => {
            if (mapStore.viewState.zoom > zoomThreshold)
                navigateToProperty(event.lngLat.lng, event.lngLat.lat);
        });

        return unsubscribeMouseDoubleClick;
    }, []);
}